class FulfillmentScheduler extends HTMLElement {
  connectedCallback() {
    this.required = this.dataset.required === 'true';
    this.minDays = Number(this.dataset.minDays || 0);
    this.maxDays = Number(this.dataset.maxDays || 14);
    this.blockedDates = this.parseCsv(this.dataset.blockedDates);
    this.blockedWeekdays = this.parseCsv(this.dataset.blockedWeekdays).map((day) =>
      day.toLowerCase()
    );
    this.noteInput = this.querySelector('[data-fulfillment-note-input]');

    this.dateInput = this.querySelector('.lla-fulfillment__date');
    this.timeSelect = this.querySelector('.lla-fulfillment__time');
    this.methodInput = this.querySelector('[data-fulfillment-method-input]');
    this.message = this.querySelector('[data-fulfillment-message]');
    this.methodButtons = this.querySelectorAll('[data-fulfillment-method]');

    this.setDateLimits();
    this.bindEvents();
    this.updateTimeframes(this.methodInput?.value || 'Delivery');
  }
  buildOrderNote() {
    const method = this.methodInput?.value || '';
    const date = this.dateInput?.value || '';
    const timeframe = this.timeSelect?.value || '';

    const lines = [
      'Fulfillment Details',
      method ? `Method: ${method}` : '',
      date ? `Date: ${date}` : '',
      timeframe ? `Timeframe: ${timeframe}` : '',
    ].filter(Boolean);

    return lines.join('\n');
  }

  syncOrderNote() {
    if (!this.noteInput) return;

    this.noteInput.value = this.buildOrderNote();
  }

  parseCsv(value) {
    if (!value) return [];

    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  bindEvents() {
    this.methodButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const method = button.dataset.fulfillmentMethod;

        this.methodButtons.forEach((currentButton) => {
          currentButton.classList.remove('is-active');
        });

        button.classList.add('is-active');

        if (this.methodInput) {
          this.methodInput.value = method;
        }

        this.updateTimeframes(method);
        this.clearMessage();
        if (this.methodInput) {
        this.methodInput.value = method;
        }

        this.updateTimeframes(method);
        this.syncOrderNote();
        this.clearMessage();
      });
      
    });

    this.dateInput?.addEventListener('change', () => {
      this.validateDate();
      this.syncOrderNote();

    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;

        if (!form.matches('form[action*="/cart/add"]')) return;
        
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  setDateLimits() {
    if (!this.dateInput) return;

    const today = new Date();
    const minDate = new Date(today);
    const maxDate = new Date(today);

    minDate.setDate(today.getDate() + this.minDays);
    maxDate.setDate(today.getDate() + this.maxDays);

    this.dateInput.min = this.formatDate(minDate);
    this.dateInput.max = this.formatDate(maxDate);
  }

  updateTimeframes(method) {
    if (!this.timeSelect) return;

    Array.from(this.timeSelect.options).forEach((option) => {
      if (!option.dataset.method) return;

      const shouldShow = option.dataset.method === method;
      option.hidden = !shouldShow;
      option.disabled = !shouldShow;
    });

    this.timeSelect.value = '';
  }

  validate() {
    this.syncOrderNote();
    if (!this.required) return true;

    if (!this.dateInput?.value) {
      this.showError('Please select a date before adding to cart.');
      return false;
    }

    if (!this.validateDate()) {
      return false;
    }

    if (!this.timeSelect?.value) {
      this.showError('Please select a timeframe before adding to cart.');
      return false;
    }

    this.clearMessage();
    return true;
  }

  validateDate() {
    if (!this.dateInput?.value) return true;

    const selectedDate = new Date(`${this.dateInput.value}T00:00:00`);
    const selectedDay = selectedDate
      .toLocaleDateString('en-US', { weekday: 'long' })
      .toLowerCase();

    if (this.blockedDates.includes(this.dateInput.value)) {
      this.dateInput.value = '';
      this.showError('That date is not available. Please choose another date.');
      return false;
    }

    if (this.blockedWeekdays.includes(selectedDay)) {
      this.dateInput.value = '';
      this.showError('That weekday is not available. Please choose another date.');
      return false;
    }

    this.clearMessage();
    return true;
  }

  showError(message) {
    if (!this.message) return;

    this.message.textContent = message;
    this.message.classList.add('is-error');
  }

  clearMessage() {
    if (!this.message) return;

    this.message.textContent = '';
    this.message.classList.remove('is-error');
  }

  formatDate(date) {
    return date.toISOString().split('T')[0];
  }
}

class ProductUpsells extends HTMLElement {
  connectedCallback() {
    this.bindCartSubmit();
  }

  bindCartSubmit() {
    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;

        if (!form.matches('form[action*="/cart/add"]')) return;

        const checkedUpsells = Array.from(
          document.querySelectorAll('.lla-upsell-card__checkbox:checked')
        );

        if (!checkedUpsells.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const formData = new FormData(form);
        const mainVariantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);

        const properties = {};

        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);

          if (match && value) {
            properties[match[1]] = value;
          }
        }

        const items = [
          {
            id: mainVariantId,
            quantity,
            properties,
          },
          ...checkedUpsells.map((upsell) => ({
            id: Number(upsell.value),
            quantity: 1,
            properties: {
              '_Added as upsell': 'Yes',
              ...properties,
            },
          })),
        ];

        const submitButton = form.querySelector('[type="submit"]');

        try {
          if (submitButton) {
            submitButton.setAttribute('aria-busy', 'true');
            submitButton.disabled = true;
          }

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) {
            throw new Error('Cart add failed');
          }

          window.location.href = '/cart';
        } catch (error) {
          console.error(error);
          window.location.href = '/cart';
        } finally {
          if (submitButton) {
            submitButton.removeAttribute('aria-busy');
            submitButton.disabled = false;
          }
        }
      },
      true
    );
  }
}

if (!customElements.get('fulfillment-scheduler')) {
  customElements.define('fulfillment-scheduler', FulfillmentScheduler);
}

if (!customElements.get('product-upsells')) {
  customElements.define('product-upsells', ProductUpsells);
}